const colors = {
  primary: '#2D323E',
  primaryDark: '#212630',
  darkRed: '#b71431',
  lightRed: 'rgb(255, 25, 67)',
  bgRed: "rgba(255, 25, 67, 0.1)",
  secondaryLight: '#c2f4b2',
  backgroundPrimary: '#DCE1F7',
  backgroundInput: '#DBE3F9',
  textPrimary: '#333',
  textSecondary: '#A1989B',
  white: '#fff',
  black: '#000',
  gray: '#e7e7e7',
  lightGray: '#f2f2f2',
  darkGray: '#aaa',
  yellow: "#ffae00",
  yellowLight: "rgba(255,174,0,0.3)",
  lightShade: '#f7f7f7',
  lightBlue: '#00a1ffad',
  lightPrimary: '#ddddddb3',
  lightPink: '#fcdbe1',
  blackShade: "rgba(0,0,0,0.4)"
};

export default colors;